import { baseService } from './base.service'

export const feedbackService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    createFeedback: builder.mutation({
      query: (body) => ({
        url: '/feedback',
        method: 'POST',
        body,
      }),
    }),
    getFeedbacks: builder.query({
      query: () => '/feedback',
      providesTags: ['Feedback'],
    }),
    getFeedback: builder.query({
      query: (id) => `/feedback/${id}`,
      providesTags: (result, error, id) => [{ type: 'Feedback', id }],
    }),
    updateFeedback: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/feedback/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Feedback', id }, 'Feedback'],
    }),
    deleteFeedback: builder.mutation({
      query: (id) => ({
        url: `/feedback/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Feedback'],
    }),
    markFeedbackAsRead: builder.mutation({
      query: (id) => ({
        url: `/feedback/${id}/mark_as_read`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Feedback', id }, 'Feedback'],
    }),
  }),
})

export const {
  useCreateFeedbackMutation,
  useGetFeedbacksQuery,
  useGetFeedbackQuery,
  useUpdateFeedbackMutation,
  useDeleteFeedbackMutation,
  useMarkFeedbackAsReadMutation,
} = feedbackService
